var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'track-btn',
    [_vm.type || ''],
    [_vm.isBlock ? 'is-block' : ''],
    [_vm.customColor ? 'custom-color' : '']
  ],style:(_vm.customStyle),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"background"}),(_vm.icon)?_c('div',{staticClass:"t-Button-Icon"},[_c('Icon',{attrs:{"name":_vm.icon,"size":_vm.iconSize,"handle-click":_vm.handleClick}})],1):_vm._e(),_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }